import { HeartIcon } from 'layouts/commons/icons';
import React, { useEffect, useState } from 'react';
import { SubMenuAccountComponent } from '../common';
import OwlCarousel from 'react-owl-carousel2';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Area, Bedrooms, Flag, RedMapPin } from 'assets/images/web-isn';
import { formatMoney } from 'utils/objects';
import { ICON_LEFT, ICON_RIGHT } from 'utils/constants';
import { Link, useParams, useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { getFavoritesAccount, getListBookings, postRemoveFavorites } from '../accountPage.api';
import { getQueryString } from 'utils/params';
import { handleDateLocale } from 'modules/paymentPage/common/formatDate';
import { postNewFavorite } from '../../serviceApartment/serviceApartment.api';
import useFullPageLoader from 'modules/commons/isn/useFullPageLoader';

function ListBookingComponent(props) {
  const [loader, showLoader, hideLoader] = useFullPageLoader();
  const { currentCurrency } = props.layout;
  const history = useHistory();
  const { t } = useTranslation();
  const { language } = useParams();
  const [currentA, setCurrentA] = useState([]);
  const [upconmingA, setUpconmingA] = useState([]);
  const [pastA, setPastA] = useState([]);
  const [like, setLike] = useState([]);

  const option = {
    items: 1,
    autoplay: false,
    loop: false,
    dots: true,
    nav: true,
    navText: [ICON_LEFT, ICON_RIGHT],
    autoHeight: true,
    responsive: {},
    animateOut: 'fadeOut',
    animateIn: 'fadeIn',
    center: true,
  };

  useEffect(() => {
    showLoader();
    getListBookings(getQueryString({ language, pageSize: 999, pageIndex: 1 })).then(res => {
      if (res?.items) {
        const newArrUpcomming = [];
        const newArrCurrent = [];
        const newArrPast = [];
        res.items.forEach(item => {
          if (item.bookingStatusId === 2) {
            newArrUpcomming.push(item);
          } else if (item.bookingStatusId === 5) {
            newArrCurrent.push(item);
          } else if (item.bookingStatusId === 6) {
            newArrPast.push(item);
          }
        });
        setUpconmingA(newArrUpcomming);
        setCurrentA(newArrCurrent);
        setPastA(newArrPast);
      }
      hideLoader();
    });
    //eslint-disable-next-line
  }, []);

  useEffect(() => {
    getFavoritesAccount(getQueryString({ language, pageSize: 999, pageIndex: 1 })).then(res => {
      if (res.data?.items !== null) {
        let likeArr = [];
        res.data.items.forEach(el => {
          likeArr.push(el.apartmentId);
        });
        setLike(likeArr);
      }
    });
    //eslint-disable-next-line
  }, []);

  const handleLike = async apartmentId => {
    let listData = [];
    if (like && like.includes(apartmentId)) {
      postRemoveFavorites(getQueryString({ listApartment: apartmentId })).then(res => {
        if (res === true) {
          listData = like.filter(i => i !== apartmentId);
          setLike(listData);
        }
      });
    } else {
      await postNewFavorite({ apartmentId }).then(res => {
        if (res.status === 'success') {
          listData = [...like, apartmentId];
          setLike(listData);
        }
      });
    }
  };

  const goToBookingDetail = item => {
    history.push(`/${language}/booking-confirm/${item.bookingNumber}`);
  };

  const currentApartment = () => {
    return (
      <>
        <div className="list-booking_title">{t('manageAccount.label_currentAp')}</div>
        {currentA.length === 0 ? (
          <div className="list-booking_title-desc">{t('manageAccount.label_noCurrentAp')}</div>
        ) : (
          <div className="row">
            {currentA.map((item, index) => {
              return (
                <div id="serviceApartment" className="p-3 col-xl-4 col-md-6 col-sm-12 col-12" key={index}>
                  <div className="project-info justify-content-center align-items-center mt-1">
                    <div className="container-slider">
                      <OwlCarousel options={option}>
                        {item.images.map((sliderImage, i) => {
                          return (
                            <div className="slide" key={i}>
                              <Link to={`/${language}/booking-confirm/${item.bookingNumber}`}>
                                <LazyLoadImage
                                  src={`${process.env.REACT_APP_ISN_IMAGE_URL}${sliderImage.url}`}
                                  alt=""
                                />
                              </Link>
                            </div>
                          );
                        })}
                      </OwlCarousel>
                    </div>
                    <div
                      // onClick={e => handleLike(e, item.apartmentId)}
                      // className={like.includes(item.apartmentId) ? 'like-contents active' : 'like-contents'}
                      className="like-contents"
                    >
                      <HeartIcon />
                    </div>
                    <div className="content" onClick={() => goToBookingDetail(item)}>
                      <div className="project-name">{item.name}</div>
                      {item.address ? (
                        <div className="apartment-address mt-2">
                          <img src={Flag} alt="flag without f" />
                          <div className="address-description ml-1">{item.address}</div>
                        </div>
                      ) : (
                        ''
                      )}
                      <div className="apartment-infomation d-flex mt-3 flex-column">
                        <div className="d-flex justify-content-between">
                          <div className="d-flex">
                            <img src={RedMapPin} alt="location" />
                            <div className="project-location ml-1">{item.district}</div>
                          </div>
                          <div className="bedroom-size d-flex">
                            <img src={Bedrooms} alt="bedrooms" />
                            <div className="project-bed">
                              {item.bedRoomName ? <span>&nbsp;{item.bedRoomName}</span> : ''}
                            </div>
                          </div>
                        </div>
                        <div className="d-flex justify-content-between">
                          <div className="mt-2">
                            <div className="project-price">
                              <span className="focus-price">
                                {currentCurrency?.code === 'USD' && item.chargeUsd
                                  ? `${currentCurrency?.symbol}${item.chargeUsd + item.vatUsd}`
                                  : currentCurrency?.code === 'VND' && item.charge
                                  ? `${formatMoney(item.charge + item.vat, 0, 0)}${currentCurrency?.symbol}`
                                  : ''}
                              </span>
                              /
                              {item.typeCode === 'long' ? (
                                <span>{t('service_apartment_isn.label_month')}</span>
                              ) : (
                                <span>
                                  {item.numberNights}{' '}
                                  {item.numberNights > 1 ? t('payment.label_nightsN') : t('payment.label_nightN')}
                                </span>
                              )}
                            </div>
                            {/* <div className="project-price" style={{ color: '#6b6b6b' }}>
                              <span className="focus-price" style={{ textDecoration: 'line-through' }}>
                                {currentCurrency?.code === 'USD' && item.isOffer === true && item.priceOffer > 0
                                  ? `${currentCurrency?.symbol}${formatMoney(item.price, 0, 0)}`
                                  : ''}
                                {currentCurrency?.code === 'VND' && item.isOffer === true && item.priceOfferVi > 0
                                  ? `${formatMoney(item.priceVi, 0, 0)}${currentCurrency?.symbol}`
                                  : ''}
                              </span>
                              {item.typeCode === 'long' && item.priceOffer > 0 && item.priceOfferVi > 0 ? (
                                <span style={{ textDecoration: 'line-through' }}>/{t('offers.label_month')}</span>
                              ) : (
                                ''
                              )}
                              {item.typeCode === 'short' && item.priceOffer > 0 && item.priceOfferVi > 0 ? (
                                <span style={{ textDecoration: 'line-through' }}>/{t('offers.label_day')}</span>
                              ) : (
                                ''
                              )}
                            </div> */}
                          </div>
                          <div className="apartment-area d-flex mt-2">
                            <img src={Area} alt="area" />
                            <div className="project-area">
                              {item.size ? `${item.size}` : ''}
                                <React.Fragment>
                                  m<sup>2</sup>
                                </React.Fragment>
                            </div>
                          </div>
                        </div>
                        <div>
                          <div className="booking-date">
                            {t('manageAccount.label_checkIn')} {handleDateLocale(item.checkinDate)}
                          </div>
                          <div className="booking-date">
                            {t('manageAccount.label_checkOut')} {handleDateLocale(item.checkoutDate)}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  {item.offerItems && item.offerItems.length > 0 ? (
                    <div className="special-offers">
                      <div className="d-flex">
                        <div className="rectangle"></div>
                        <div className="triangle-right"></div>
                      </div>
                      <span className="text">{t('label_special_offers')}</span>
                    </div>
                  ) : (
                    ''
                  )}
                </div>
              );
            })}
          </div>
        )}
      </>
    );
  };

  const upcomingApartment = () => {
    return (
      <>
        <div className="list-booking_title">{t('manageAccount.label_currentUp')}</div>
        {upconmingA.length === 0 ? (
          <div className="list-booking_title-desc">{t('manageAccount.label_noUpcomingAp')}</div>
        ) : (
          <div className="row">
            {upconmingA.map((item, index) => {
              return (
                <div id="serviceApartment" className="p-3 col-xl-4 col-md-6 col-sm-12 col-12" key={index}>
                  <div className="project-info justify-content-center align-items-center mt-1">
                    <div className="container-slider">
                      <OwlCarousel options={option}>
                        {item.images.map((sliderImage, i) => {
                          return (
                            <div className="slide" key={i}>
                              <Link to={`/${language}/booking-confirm/${item.bookingNumber}`}>
                                <LazyLoadImage
                                  src={`${process.env.REACT_APP_ISN_IMAGE_URL}${sliderImage.url}`}
                                  alt=""
                                />
                              </Link>
                            </div>
                          );
                        })}
                      </OwlCarousel>
                    </div>
                    <div
                      onClick={() => handleLike(item.apartmentId)}
                      className={like.includes(item.apartmentId) ? 'like-contents active' : 'like-contents'}
                    >
                      <HeartIcon />
                    </div>
                    <div className="content" onClick={() => goToBookingDetail(item)}>
                      <div className="project-name">{item.name}</div>
                      {item.address ? (
                        <div className="apartment-address mt-2">
                          <img src={Flag} alt="flag without f" />
                          <div className="address-description ml-1">{item.address}</div>
                        </div>
                      ) : (
                        ''
                      )}
                      <div className="apartment-infomation d-flex mt-3 flex-column">
                        <div className="d-flex justify-content-between">
                          <div className="d-flex">
                            <img src={RedMapPin} alt="location" />
                            <div className="project-location ml-1">{item.district}</div>
                          </div>
                          <div className="bedroom-size d-flex">
                            <img src={Bedrooms} alt="bedrooms" />
                            <div className="project-bed">
                              {item.bedRoomName ? <span>&nbsp;{item.bedRoomName}</span> : ''}
                            </div>
                          </div>
                        </div>
                        <div className="d-flex justify-content-between">
                          <div className="mt-2">
                            <div className="project-price">
                              <span className="focus-price">
                                {currentCurrency?.code === 'USD' && item.chargeUsd
                                  ? `${currentCurrency?.symbol}${item.chargeUsd + item.vatUsd}`
                                  : currentCurrency?.code === 'VND' && item.charge
                                  ? `${formatMoney(item.charge + item.vat, 0, 0)}${currentCurrency?.symbol}`
                                  : ''}
                              </span>
                              /
                              {item.typeCode === 'long' ? (
                                <span>{t('service_apartment_isn.label_month')}</span>
                              ) : (
                                <span>
                                  {item.numberNights}{' '}
                                  {item.numberNights > 1 ? t('payment.label_nightsN') : t('payment.label_nightN')}
                                </span>
                              )}
                            </div>
                            {/* <div className="project-price" style={{ color: '#6b6b6b' }}>
                              <span className="focus-price" style={{ textDecoration: 'line-through' }}>
                                {currentCurrency?.code === 'USD' && item.isOffer === true && item.priceOffer > 0
                                  ? `${currentCurrency?.symbol}${formatMoney(item.price, 0, 0)}`
                                  : ''}
                                {currentCurrency?.code === 'VND' && item.isOffer === true && item.priceOfferVi > 0
                                  ? `${formatMoney(item.priceVi, 0, 0)}${currentCurrency?.symbol}`
                                  : ''}
                              </span>
                              {item.typeCode === 'long' && item.priceOffer > 0 && item.priceOfferVi > 0 ? (
                                <span style={{ textDecoration: 'line-through' }}>/{t('offers.label_month')}</span>
                              ) : (
                                ''
                              )}
                              {item.typeCode === 'short' && item.priceOffer > 0 && item.priceOfferVi > 0 ? (
                                <span style={{ textDecoration: 'line-through' }}>/{t('offers.label_day')}</span>
                              ) : (
                                ''
                              )}
                            </div> */}
                          </div>
                          <div className="apartment-area d-flex mt-2">
                            <img src={Area} alt="area" />
                            <div className="project-area">
                              {item.size ? `${item.size}` : ''}
                                <React.Fragment>
                                  m<sup>2</sup>
                                </React.Fragment>
                            </div>
                          </div>
                        </div>
                        <div>
                          <div className="booking-date">
                            {t('manageAccount.label_checkIn')} {handleDateLocale(item.checkinDate)}
                          </div>
                          <div className="booking-date">
                            {t('manageAccount.label_checkOut')} {handleDateLocale(item.checkoutDate)}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  {item.offerItems && item.offerItems.length > 0 ? (
                    <div className="special-offers">
                      <div className="d-flex">
                        <div className="rectangle"></div>
                        <div className="triangle-right"></div>
                      </div>
                      <span className="text">{t('label_special_offers')}</span>
                    </div>
                  ) : (
                    ''
                  )}
                </div>
              );
            })}
          </div>
        )}
      </>
    );
  };

  const pastApartment = () => {
    return (
      <>
        <div className="list-booking_title">{t('manageAccount.label_currentPre')}</div>
        {pastA.length === 0 ? (
          <div className="list-booking_title-desc">{t('manageAccount.label_noPreAp')}</div>
        ) : (
          <div className="row">
            {pastA.map((item, index) => {
              return (
                <div id="serviceApartment" className="p-3 col-xl-4 col-md-6 col-sm-12 col-12" key={index}>
                  <div className="project-info justify-content-center align-items-center mt-1">
                    <div className="container-slider">
                      <OwlCarousel options={option}>
                        {item.images.map((sliderImage, i) => {
                          return (
                            <div className="slide" key={i}>
                              <Link to={`/${language}/booking-confirm/${item.bookingNumber}`}>
                                <LazyLoadImage
                                  src={`${process.env.REACT_APP_ISN_IMAGE_URL}${sliderImage.url}`}
                                  alt=""
                                />
                              </Link>
                            </div>
                          );
                        })}
                      </OwlCarousel>
                    </div>
                    <div
                      // onClick={e => handleLike(e, item.apartmentId)}
                      // className={like.includes(item.apartmentId) ? 'like-contents active' : 'like-contents'}
                      className="like-contents"
                    >
                      <HeartIcon />
                    </div>
                    <div className="content" onClick={() => goToBookingDetail(item)}>
                      <div className="project-name">{item.name}</div>
                      {item.address ? (
                        <div className="apartment-address mt-2">
                          <img src={Flag} alt="flag without f" />
                          <div className="address-description ml-1">{item.address}</div>
                        </div>
                      ) : (
                        ''
                      )}
                      <div className="apartment-infomation d-flex mt-3 flex-column">
                        <div className="d-flex justify-content-between">
                          <div className="d-flex">
                            <img src={RedMapPin} alt="location" />
                            <div className="project-location ml-1">{item.district}</div>
                          </div>
                          <div className="bedroom-size d-flex">
                            <img src={Bedrooms} alt="bedrooms" />
                            <div className="project-bed">
                              {item.bedRoomName ? <span>&nbsp;{item.bedRoomName}</span> : ''}
                            </div>
                          </div>
                        </div>
                        <div className="d-flex justify-content-between">
                          <div className="mt-2">
                            <div className="project-price">
                              <span className="focus-price">
                                {currentCurrency?.code === 'USD' && item.chargeUsd
                                  ? `${currentCurrency?.symbol}${item.chargeUsd + item.vatUsd}`
                                  : currentCurrency?.code === 'VND' && item.charge
                                  ? `${formatMoney(item.charge + item.vat, 0, 0)}${currentCurrency?.symbol}`
                                  : ''}
                              </span>
                              /
                              {item.typeCode === 'long' ? (
                                <span>{t('service_apartment_isn.label_month')}</span>
                              ) : (
                                <span>
                                  {item.numberNights}{' '}
                                  {item.numberNights > 1 ? t('payment.label_nightsN') : t('payment.label_nightN')}
                                </span>
                              )}
                            </div>
                            {/* <div className="project-price" style={{ color: '#6b6b6b' }}>
                              <span className="focus-price" style={{ textDecoration: 'line-through' }}>
                                {currentCurrency?.code === 'USD' && item.isOffer === true && item.priceOffer > 0
                                  ? `${currentCurrency?.symbol}${formatMoney(item.price, 0, 0)}`
                                  : ''}
                                {currentCurrency?.code === 'VND' && item.isOffer === true && item.priceOfferVi > 0
                                  ? `${formatMoney(item.priceVi, 0, 0)}${currentCurrency?.symbol}`
                                  : ''}
                              </span>
                              {item.typeCode === 'long' && item.priceOffer > 0 && item.priceOfferVi > 0 ? (
                                <span style={{ textDecoration: 'line-through' }}>/{t('offers.label_month')}</span>
                              ) : (
                                ''
                              )}
                              {item.typeCode === 'short' && item.priceOffer > 0 && item.priceOfferVi > 0 ? (
                                <span style={{ textDecoration: 'line-through' }}>/{t('offers.label_day')}</span>
                              ) : (
                                ''
                              )}
                            </div> */}
                          </div>
                          <div className="apartment-area d-flex mt-2">
                            <img src={Area} alt="area" />
                            <div className="project-area">
                              {item.size ? `${item.size}` : ''}
                                <React.Fragment>
                                  m<sup>2</sup>
                                </React.Fragment>
                            </div>
                          </div>
                        </div>
                        <div>
                          <div className="booking-date">
                            {t('manageAccount.label_checkIn')} {handleDateLocale(item.checkinDate)}
                          </div>
                          <div className="booking-date">
                            {t('manageAccount.label_checkOut')} {handleDateLocale(item.checkoutDate)}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  {item.offerItems && item.offerItems.length > 0 ? (
                    <div className="special-offers">
                      <div className="d-flex">
                        <div className="rectangle"></div>
                        <div className="triangle-right"></div>
                      </div>
                      <span className="text">{t('label_special_offers')}</span>
                    </div>
                  ) : (
                    ''
                  )}
                </div>
              );
            })}
          </div>
        )}
      </>
    );
  };

  return (
    <>
      <SubMenuAccountComponent />
      <div id="listBooking" className="container">
        {currentApartment()}
        <div className="list-booking_boder"></div>
        {upcomingApartment()}
        <div className="list-booking_boder"></div>
        {pastApartment()}
      </div>
      {loader}
    </>
  );
}

const mapStatetoProps = state => ({
  ...state,
});

const mapDispatchToProps = dispatch => bindActionCreators({}, dispatch);

export default connect(mapStatetoProps, mapDispatchToProps)(ListBookingComponent);
